import { Control } from "react-hook-form";
import { useEffect, useState } from "react";
import { endpointPrincipal } from "../../../../../../api/endPoints/endpointPrincipal/endpointPrincipal";
import { toast } from "react-toastify";
import CustomSelect, { OpcaoSelect } from "../../../../../../components/Formularios/Inputs/CustomSelect";

interface SelectFiliaisProps {
  name: string;
  control: Control<any>;
  label: string;
  idEmpresa?: number | string;
  disabled?: boolean;
}

interface FilialOption {
  id_filial: number;
  fantasia: string;
}

export const SelectFiliais = ({ name, control, label, idEmpresa, disabled = false }: SelectFiliaisProps) => {
  const [filiais, setFiliais] = useState<OpcaoSelect[]>([]);

  useEffect(() => {
    const carregarFiliais = async () => {
      if (!idEmpresa) {
        setFiliais([]);
        return;
      }

      try {
        const { data } = await endpointPrincipal.get(`empresas-filiais/empresa/${idEmpresa}`);

        setFiliais(
          (Array.isArray(data) ? (data as FilialOption[]) : []).map((filial) => ({
            valor: filial.id_filial,
            label: filial.fantasia,
          }))
        );
      } catch (error) {
        console.error("Erro ao carregar filiais:", error);
        toast.error("Erro ao carregar filiais");
        setFiliais([]);
      }
    };

    carregarFiliais();
  }, [idEmpresa]);

  return (
    <CustomSelect
      name={name}
      control={control}
      label={label}
      opcoes={filiais}
      disabled={disabled || !idEmpresa}
    />
  );
};
